<template>
  <wsp-modal>
    <v-card v-if="showingAddressSummary">
      <v-card-title class="pa-0">
        <v-toolbar class="primary" dark dense flat>
          <v-toolbar-title>
            {{ $t('teletag.letter.title') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="showingAddressSummary = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <h3 class="mt-2 mb-3 grey--text text--darken-1 body-2">
          {{ $t('teletag.letter.validateAddress') }}
        </h3>
        <v-card class="pa-5" v-html="addressSummary"></v-card>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          round
          flat
          color="primary"
          class="capitalize"
          @click="showingAddressSummary = false"
        >
          {{ $t('global.button.cancel') }}
        </v-btn>

        <v-btn
          round
          flat
          :loading="isLoading"
          color="accent"
          class="capitalize"
          outline
          @click="submit"
        >
          {{ $t('global.button.send') }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card flat class="pb-3" v-else>
      <v-card-title class="pa-0">
        <v-toolbar class="primary" dark dense flat>
          <v-toolbar-title>
            {{ $t('teletag.letter.title') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="visible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-layout row wrap>
          <v-flex xs12 sm5>
            <advice
              color="warning"
              v-if="shoudPayLetter"
              class="d-inline-block"
            >
              {{
                $t('teletag.letter.legend.teletagPrice', {
                  teletagPrice: teletagPrice,
                })
              }}
            </advice>
          </v-flex>
          <v-flex xs12 sm7>
            <advice
              color="warning"
              class="d-inline-block"
              v-if="showLimitZonesOfChile"
            >
              {{ $t('teletag.letter.advice.chile') }}
              <a :href="chileComunasLink" target="_blank" class="right">{{
                $t('teletag.letter.advice.chileLink')
              }}</a>
            </advice>
          </v-flex>
        </v-layout>
      </v-card-title>

      <v-form
        ref="form"
        v-model="valid"
        v-on:submit.prevent="
          () => {
            return false;
          }
        "
      >
        <v-card-text>
          <v-combobox
            :items="address"
            v-if="showComboAddress"
            item-text="text"
            item-value="id"
            solo
            flat
            :label="$t('teletag.letter.chooseAddress')"
            return-object
            v-model="addressSelected"
            @change="updateFormValues"
            class="pa-0"
          >
            <slot name="default"></slot>
          </v-combobox>

          <v-layout row wrap>
            <v-flex xs12 sm6 class="px-2">
              <v-text-field
                :label="$t('global.placeholder.firstname')"
                v-model="letter.firstname"
                name="firstname"
                :rules="mandatoryRules"
                type="text"
                required
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm6 class="px-2">
              <v-text-field
                :label="$t('global.placeholder.lastname')"
                v-model="letter.lastname"
                name="lastname"
                :rules="mandatoryRules"
                type="text"
                required
              >
              </v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12 sm9 class="px-2">
              <v-text-field
                :label="$t('global.placeholder.street')"
                v-model="letter.street"
                name="street"
                :rules="mandatoryRules"
                type="text"
                required
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm3 class="px-2">
              <v-text-field
                :label="$t('teletag.letter.placeholder.addressDetail')"
                v-model="letter.detail"
                name="detail"
                type="text"
              >
              </v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12 sm5 class="px-2">
              <v-text-field
                :label="$t('global.placeholder.postcode')"
                v-model="letter.postcode"
                name="postcode"
                :rules="mandatoryRules"
                type="text"
                required
              >
              </v-text-field>
            </v-flex>
            <v-flex xs6 sm4 class="px-2">
              <v-text-field
                :label="$t('global.placeholder.city')"
                v-model="letter.city"
                name="city"
                :rules="mandatoryRules"
                type="text"
                required
              >
              </v-text-field>
            </v-flex>
            <v-flex xs6 sm3 class="px-2">
              <v-text-field
                :label="$t('teletag.letter.placeholder.numberTeletags')"
                v-model="letter.numberTags"
                :disabled="!isUserActive"
                name="numberTags"
                type="number"
                min="1"
                required
              >
              </v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-layout>
            <v-flex text-xs-right xs12>
              <v-btn
                round
                flat
                color="primary"
                class="capitalize"
                @click="visible = !visible"
              >
                {{ $t('global.button.cancel') }}
              </v-btn>

              <v-btn
                round
                flat
                color="primary"
                class="capitalize"
                @click="resetForm"
              >
                {{ $t('global.button.clear') }}
              </v-btn>

              <v-btn
                :disabled="!valid"
                type="submit"
                outline
                color="accent"
                class="capitalize white--text"
                @click="showValidateAddress"
                round
              >
                {{ $t('global.button.send') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-form>
    </v-card>
  </wsp-modal>
</template>

<script>
import WspModal from '@/components/commons/WspModal';
import Advice from '@/components/commons/Advice';
import addressService from '@/services/addressService';
import letterService from '@/services/letterService';
import manageErrorService from '@/services/manageErrorService';
import utilService from '@/services/utilService';
import store from '@/store';
import _ from 'lodash';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';
import userService from '../../../services/userService';

export default {
  name: 'RequestLetterForm',
  components: {
    [Advice.name]: Advice,
    [WspModal.name]: WspModal,
  },
  watch: {
    visible: function (value) {
      if (!value) {
        this.$emit('on-close', {});
      }
    },
  },
  computed: {
    showComboAddress() {
      return this.address.length > 1;
    },
    isUserActive() {
      return userService.isActived();
    },
    shoudPayLetter() {
      return userService.shoudPayLetter();
    },
    defaultSelected() {
      return {
        id: 0,
        text: this.$i18n.t('teletag.letter.newAddress'),
      };
    },
    showLimitZonesOfChile() {
      return utilService.isChile();
    },

    chileComunasLink() {
      return 'https://s3-eu-west-1.amazonaws.com/9sp-public/legal/chile/comunas_excluidas_para_despacho_de_StickerTags_en_Santiago.pdf';
    },

    mandatoryRules() {
      return [
        (v) => !!v || this.$i18n.t('global.validation.required.text'),
        (v) =>
          (!!v && v.trim().length !== 0) ||
          this.$i18n.t('global.validation.required.text'),
      ];
    },
    teletagPrice() {
      let price = store.state.countrySelected.prices.teletag;
      return this.$options.filters.addCurrencySymbol(price);
    },
  },
  data() {
    return {
      visible: true,
      isLoading: false,
      valid: false,
      address: [],
      addressSelected: {},
      letter: {
        firstname: store.state.user.firstname,
        lastname: store.state.user.lastname,
        numberTags: 1,
        city: store.state.citySelected.name,
        country: store.state.countrySelected.name,
      },
      showingAddressSummary: false,
      addressSummary: '',
    };
  },
  created() {
    this.resetForm();
    this.showingAddressSummary = false;
    this.addressSelected = this.defaultSelected;
    this.loadAddress();
  },
  methods: {
    async loadAddress() {
      let results = await addressService.list();

      if (results.error) {
        manageErrorService.handle(results.data);
        this.ticketLoading = false;
        return;
      }

      this.address.push(this.defaultSelected);

      if (results.data) {
        _.each(results.data, (obj) => {
          this.address.push({
            id: obj.id,
            text: `${obj.street} ${obj.detail}, ${obj.postcode} ${obj.city}`,
            street: obj.street,
            detail: obj.detail,
            postcode: obj.postcode,
            city: obj.city,
          });
        });
      }
    },

    updateFormValues() {
      let id = this.addressSelected.id;
      if (id === 0) {
        this.resetForm();
      } else {
        let address = _.find(this.address, function (o) {
          return o.id === id;
        });
        this.letter.street = address.street;
        this.letter.detail = address.detail;
        this.letter.postcode = address.postcode;
        this.letter.city = address.city;
      }
    },

    resetForm() {
      this.addressSummary = '';
      this.letter.firstname = '';
      this.letter.lastname = '';
      this.letter.street = '';
      this.letter.detail = '';
      this.letter.postcode = '';
      this.letter.city = '';
    },

    async showValidateAddress() {
      let isValidate = await this.$refs.form.validate();
      if (!isValidate) {
        return false;
      }

      let summary1 = `${this.letter.firstname}, ${this.letter.lastname}`;
      let summary2 = this.letter.street;
      if (this.letter.detail) {
        summary2 += `, ${this.letter.detail}`;
      }
      let summary3 = `${this.letter.postcode}, ${this.letter.city}, ${this.letter.country}`;

      // let cleanForm = _(this.letter).omit(_.isUndefined).omit(_.isNull).value();

      this.addressSummary = `
        ${summary1},
        ${summary2},
        ${summary3}
      `;
      this.showingAddressSummary = true;
    },

    async submit() {
      this.isLoading = true;

      let results = await letterService.create(this.letter);

      if (results.error) {
        manageErrorService.handle(results.data);
        this.isLoading = false;
        this.valid = true;
        return;
      }

      this.visible = false;

      this.$emit('on-success', {});

      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: this.$i18n.t('teletag.letter.toast.success'),
        type: 'info',
        doNotTranslate: true,
      });

      this.$mam.eventRegisterStep4();

      this.isLoading = false;
    },
  },
};
</script>
